import { useIsPrescriber } from './useIsPrescriber';

/**
 * Alias for {@link useIsPrescriber} that exposes Airtable `is_prescriber` as
 * `isMedicalDoctor`. Kept so GrowthBook targeting (`isMedicalDoctor` attribute)
 * and legacy consumers (chat gating, prescriber-flow sync) keep their established
 * name without a second network request.
 */
export const useIsMedicalDoctor = () => {
  const { isPrescriber, isLoading, isError } = useIsPrescriber();

  return {
    isMedicalDoctor: isPrescriber,
    isLoading,
    isError,
  };
};
